module.exports = __webpack_public_path__ + "static/media/ic_视频动作.02ea0938.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ic_视频动作.svg
// module id = 405
// module chunks = 0